class Storage {
  constructor() {
    this.dbName = 'infowareDetourEditor';
    this.schemaOptions = 'options';
    this.db = null;
    this.schemaReady = false;
  }

  init() {
    return new Promise((resolve, reject) => {
      const request = window.indexedDB.open(this.dbName, 2);

      request.onerror = (event) => {
        reject(event);
      };

      request.onsuccess = (event) => {
        this.db = event.target.result;

        resolve(true);
      };

      request.onupgradeneeded = (event) => {
        this.db = event.target.result;

        const objectStore = this.db.createObjectStore(this.schemaOptions, { keyPath: 'key' });

        objectStore.transaction.oncomplete = () => {
          this.schemaReady = true;
        };
      };
    });
  }

  putOption(key, value) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.schemaOptions], 'readwrite');
      const objectStore = transaction.objectStore(this.schemaOptions);

      objectStore.put({ key, value });

      transaction.oncomplete = () => { resolve(true); };
      transaction.onerror = (event) => { reject(event); };
    });
  }

  getOption(key) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.schemaOptions]);
      const objectStore = transaction.objectStore(this.schemaOptions);

      const request = objectStore.get(key);

      request.onsuccess = () => {
        const { result } = request;

        if (result) {
          resolve(result.value);
        } else {
          resolve(null);
        }
      };
      request.onerror = (event) => { reject(event); };
    });
  }

  deleteOption(key) {
    return new Promise((resolve, reject) => {
      const request = this.db.transaction([this.schemaOptions], 'readwrite')
        .objectStore(this.schemaOptions)
        .delete(key);

      request.onsuccess = () => { resolve(true); };
      request.onerror = (event) => { reject(event); };
    });
  }
}

module.exports = Storage;
